<template>
  <b-table-simple class="table-principal">
    <b-thead class="thead-data">
    <b-th>Estudiante</b-th>
    <b-th>Periodo</b-th>
    <b-th>Grado</b-th>
    <b-th>Seccion</b-th>
    <b-th>Correo</b-th>
    <b-th>DNI</b-th>
    <b-th>Celular</b-th>
    <b-th>Carrera</b-th>
    <b-th></b-th>
    </b-thead>
    <b-tbody class="table-tbody-data">
      <b-tr class="table-student" v-for="(item,key) in data" :key="key">
        <b-td>{{item.nombre}}</b-td>
        <b-td>2019</b-td>
        <b-td>{{item.grado_nombre}}</b-td>
        <b-td>{{item.seccion_nombre}}</b-td>
        <b-td class="field-email">{{item.correo}}</b-td>
        <b-td>{{item.dni}}</b-td>
        <b-td>{{item.celular}}</b-td>
        <b-td>{{item.carrera}}</b-td>
        <b-td>
          <b-button @click="exportExcel(item)" class="button-download">Descargar</b-button>
        </b-td>
      </b-tr>
    </b-tbody>
  </b-table-simple>
  

</template>
<script>
import XLSX from "xlsx";

export default {
  name: "Navbar",
  props: {
    data: Array,
    columns: Array,
    filterKey: String
  },
  data: () => ({}),
  filters: {},
  methods: {
    exportExcel(item) {
             
      let datas ={
        Grado: item.grado_nombre,
        Seccion: item.seccion_nombre,
        Correo: item.correo,
        DNI: item.dni,
        Celular: item.celular,
        Nombre: item.nombre

      }
      let data = XLSX.utils.json_to_sheet([datas]);
      let workbook = XLSX.utils.book_new();
      let filename = "estudiante";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    }
  }
};
</script>
<style scoped>
</style>
